import type { WeekColumn } from "@/utils/weekUtils";
import { isoKey } from "@/utils/weekUtils";

interface ProjectWeekHeaderRowProps {
  weeks: WeekColumn[];
}

export function ProjectWeekHeaderRow({ weeks }: ProjectWeekHeaderRowProps) {
  return (
    <div className="week-header-row week-header-row--project">
      <div className="week-header-row__timeline">
        <div
          className="timeline-grid"
          style={{ gridTemplateColumns: `repeat(${weeks.length}, 64px)` }}
        >
          {weeks.map((week) => (
            <div
              key={isoKey(week)}
              className="timeline-cell timeline-cell--header"
            >
              <span className="timeline-cell__label">{week.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

